import React, { useEffect, useState } from 'react';
import { displayTime, utcOffset } from './sportsTime';

export default function VenueClock({ timeZone, suppliedZone, compact = false }) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 30000);
    return () => clearInterval(timer);
  }, []);
  if (compact) return <aside className="sports-calendar__clock" aria-label="Venue time reference"><strong>{displayTime(now, timeZone)}</strong><span>{timeZone} · {utcOffset(now, timeZone)}</span>{suppliedZone !== timeZone && <small>Vietnam timezone fallback</small>}</aside>;
  return <aside className="sports-fixtures__clock" aria-label="Venue time reference">
    <div><span className="sports-fixtures__eyebrow">Venue time · 24-hour clock</span>
      <strong>{displayTime(now, timeZone)}</strong><span>{timeZone} · {utcOffset(now, timeZone)}</span></div>
    <p>{suppliedZone === timeZone ? 'All listings and fixture entry use this timezone, including when you browse away from the venue.'
      : 'Using the Vietnam pilot timezone because a valid venue timezone has not been supplied.'}
      {' '}Broadcast start is separate from fixture kickoff. Listings do not confirm playback.</p>
  </aside>;
}
